import Api from 'utils/api'

export const fetchUsers = ({ limit, department, offset, ordering, search }) =>
  Api.get(['users'], { limit, department, offset, ordering, search })

export const fetchUserDepartments = (
  departmentId,
  { limit, offset, ordering },
) =>
  Api.get([`users/${departmentId}/departments`], {
    limit,
    offset,
    ordering,
  })

export const fetchUserDepartmentProjects = (
  departmentId,
  projectId,
  { limit, offset, ordering, search },
) =>
  Api.get([`users/${departmentId}/departments/${projectId}/projects`], {
    limit,
    offset,
    ordering,
    search,
  })

// edit, delete, add & invite user

export const postUser = payload => Api.post(['users'], payload)

export const patchUser = (pk, payload) => Api.patch(['users', pk], payload)

export const deleteUser = pk => Api.delete(['users', pk])

export const inviteUser = pk => Api.post(['users', pk, 'send-credentials'])

// edit access to a single department

export const postUserDepartment = ({ pk, departmentId }) =>
  Api.post(['users', pk, 'departments'], { id: departmentId })

export const deleteUserDepartment = ({ pk, departmentId }) =>
  Api.delete(['users', pk, 'departments', departmentId])

// edit access to a single project

export const postProjectAccess = ({ pk, departmentId, projectId }) =>
  Api.post(['users', pk, 'departments', departmentId, 'projects'], {
    id: projectId,
  })

export const deleteProjectAccess = ({ pk, departmentId, projectId }) =>
  Api.delete(['users', pk, 'departments', departmentId, 'projects', projectId])

// edit access to multiple projects at once

export const postDepartmentProjectsAccess = ({ pk, departmentId }) =>
  Api.post(['users', pk, 'departments', departmentId, 'projects'])

export const deleteDepartmentProjectsAccess = ({ pk, departmentId }) =>
  Api.delete(['users', pk, 'departments', departmentId], {
    only_project_access: 1,
  })

// check if user has access to all projects in department

export const fetchAllProjectsAccess = ({ pk, departmentId }) =>
  Api.get(['users', pk, 'departments', departmentId])
